import { render, staticRenderFns } from "./CertificateScan.vue?vue&type=template&id=6843f1c0&scoped=true"
import script from "./CertificateScan.vue?vue&type=script&lang=js"
export * from "./CertificateScan.vue?vue&type=script&lang=js"
import style0 from "./CertificateScan.vue?vue&type=style&index=0&id=6843f1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6843f1c0",
  null
  
)

export default component.exports